# user
export SET_AUTH_TOKEN                = 'SET_AUTH_TOKEN'
export SET_USER_ACLS                 = 'SET_USER_ACLS'
export SET_USER_ROLES                = 'SET_USER_ROLES'

# projects
export ADD_PROJECT                   = 'ADD_PROJECT'
export DELETE_PROJECT                = 'DELETE_PROJECT'
export LIST_PROJECTS                 = 'LIST_PROJECTS'
export SET_CONFIG_ENABLED            = 'SET_CONFIG_ENABLED'
export SET_CURRENT_PROJECT           = 'SET_CURRENT_PROJECT'
export SET_FILES                     = 'SET_FILES'

# branch
export SET_CURRENT_BRANCH            = 'SET_CURRENT_BRANCH'
export SET_BRANCHES                  = 'SET_BRANCHES'

# explore
export SET_CREATING_NODE             = 'SET_CREATING_NODE'
export SET_DARK_MODE_ENABLED         = 'SET_DARK_MODE_ENABLED'
export SET_EDITING_NODE              = 'SET_EDITING_NODE'
export SET_CURRENT_ITEM              = 'SET_CURRENT_ITEM'
export SET_DETAIL_POPUP              = 'SET_DETAIL_POPUP'
export SET_DISABLED_RELATIONS        = 'SET_DISABLED_RELATIONS'
export SET_DISABLED_TYPES            = 'SET_DISABLED_TYPES'
export SET_HIDE_CHANGELOG            = 'SET_HIDE_CHANGELOG'
export SET_ID_PREFIX                 = "SET_ID_PREFIX"
export SET_ID_TYPE                   = "SET_ID_TYPE"
export SET_MACROS                    = 'SET_MACROS'
export SET_MEMBER_KEYS               = 'SET_MEMBER_KEYS'
export SET_NAME_KEYS                 = 'SET_NAME_KEYS'
export SET_NAMESPACES                = 'SET_NAMESPACES'
export SET_ENABLE_NAMESPACES         = 'SET_ENABLE_NAMESPACES'
export SET_OPEN_IN_CONSOLE           = 'SET_OPEN_IN_CONSOLE'
export SET_PLUGINS                   = 'SET_PLUGINS'
export SET_RELATION_LABELS           = 'SET_RELATION_LABELS'
export SET_NODE_FORM_INITIAL_VALUES  = 'SET_NODE_FORM_INITIAL_VALUES'
export SET_TAB                       = 'SET_TAB'
export SET_TABLE_CONFIG              = 'SET_TABLE_CONFIG'
export SET_TAB_DISABLED              = 'SET_TAB_DISABLED'
export SET_TYPES_MAP                 = 'SET_TYPES_MAP'
export SET_WINDOW_DIMS               = 'SET_WINDOW_DIMS'
export TOGGLE_TAB_IS_LOCKED          = 'TOGGLE_TAB_IS_LOCKED'
export TOGGLE_SEARCH_MODAL           = 'TOGGLE_SEARCH_MODAL'

# graph
export CLEAR_GRAPH                   = 'CLEAR_GRAPH'
export REMOVE_GRAPH_EDGE             = 'REMOVE_GRAPH_EDGE'
export REMOVE_GRAPH_EDGES            = 'REMOVE_GRAPH_EDGES'
export REMOVE_GRAPH_NODE             = 'REMOVE_GRAPH_NODE'
export REMOVE_GRAPH_NODES            = 'REMOVE_GRAPH_NODES'
export SET_DEVTOOLS_ENABLED          = 'SET_DEVTOOLS_ENABLED'
export SET_GRAPH_ADDING_EDGE         = 'SET_GRAPH_ADDING_EDGE'
export SET_GRAPH_CREATING_EDGE       = 'SET_GRAPH_CREATING_EDGE'
export SET_GRAPH_EDITING_LABELS      = 'SET_GRAPH_EDITING_LABELS'
export SET_GRAPH_NODE_VIEW           = 'SET_GRAPH_NODE_VIEW'
export SET_GRAPH_NODES               = 'SET_GRAPH_NODES'
export SET_GRAPH_SHOWING_NODE        = 'SET_GRAPH_SHOWING_NODE'
export SET_NODE_LIMIT                = 'SET_NODE_LIMIT'
export SET_SHOW_RELATIONS_AS_NODES   = 'SET_SHOW_RELATIONS_AS_NODES'
export UPDATE_GRAPH_NODES            = 'UPDATE_GRAPH_NODES'
export UPDATE_IS_ABSTRACT            = 'UPDATE_IS_ABSTRACT'
export UPDATE_GRAPH_GROUPS           = 'UPDATE_GRAPH_GROUPS'
export SET_USER_MODE                 = 'SET_USER_MODE'

# home tree
export DELETE_HOMETREE_ACTION        = 'DELETE_HOMETREE_ACTION'
export DELETE_HOMETREE_VIEW          = 'DELETE_HOMETREE_VIEW'
export DELETE_HOMETREE_MACRO         = 'DELETE_HOMETREE_MACRO'
export SET_HOMETREE_EXPANDED         = 'SET_HOMETREE_EXPANDED'
export SET_HOMETREE_NODE_DATA        = 'SET_HOMETREE_NODE_DATA'
export SET_HOMETREE_ROOTS            = 'SET_HOMETREE_ROOTS'
export SET_HOMETREE_TREE_DATA        = 'SET_HOMETREE_TREE_DATA'
export UPDATE_HOMETREE_NODE_DATA     = 'UPDATE_HOMETREE_NODE_DATA'
export UPDATE_HOMETREE_TREE_DATA     = 'UPDATE_HOMETREE_TREE_DATA'
